import { render } from "./transit-modal.vue?vue&type=template&id=13213cc2"
import script from "./transit-modal.vue?vue&type=script&lang=js"
export * from "./transit-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__